module.exports = __webpack_public_path__ + "img/ss.f54ecff4.png";